export default __webpack_public_path__ + "static/media/cash.abf0bc95.svg";